module.exports = __webpack_public_path__ + "static/img/icon_03.5c302885.svg";